import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, ArrowLeft, Home, Building, Building2, Store, TreePine, Warehouse } from "lucide-react";
import Cookies from "js-cookie";

const PROPERTY_TYPES = [
  { link: "/create/house",      Icon: Home,      title: "บ้านเดี่ยว",      sub: "Single detached house", color: "bg-orange-50 text-orange-500" },
  { link: "/create/townhouse",  Icon: Building,  title: "ทาวน์เฮ้าส์",    sub: "Townhouse / Townhome",  color: "bg-blue-50 text-blue-500"   },
  { link: "/create/condo",      Icon: Building2, title: "คอนโด",           sub: "Condominium",           color: "bg-violet-50 text-violet-500"},
  { link: "/create/commercial", Icon: Store,     title: "อาคารพาณิชย์",   sub: "Commercial building",   color: "bg-amber-50 text-amber-500"  },
  { link: "/create/land",       Icon: TreePine,  title: "ที่ดิน",          sub: "Land / Plot",           color: "bg-green-50 text-green-500"  },
  { link: "/create/others",     Icon: Warehouse, title: "โกดัง / โรงงาน", sub: "Warehouse / Factory",   color: "bg-gray-100 text-gray-500"   },
];

function PropertyCard({ link, Icon, title, sub, color, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.05 * index }}
    >
      <Link to={link}>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4 px-4 py-3.5 hover:shadow-md hover:border-postperty/20 transition-all group">
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${color}`}>
            <Icon size={22} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800">{title}</p>
            <p className="text-xs text-gray-400 mt-0.5">{sub}</p>
          </div>
          <ChevronRight size={18} className="text-gray-300 flex-shrink-0 group-hover:text-postperty transition-colors" />
        </div>
      </Link>
    </motion.div>
  );
}

export default function SelectPostType() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Cookies.get("jwt")) navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-xl mx-auto px-4 pt-8 pb-24">

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="flex items-center gap-3 mb-6"
        >
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <ArrowLeft size={16} className="text-gray-500" />
          </button>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-0.5">ลงประกาศขายเอง</p>
            <h1 className="text-lg font-bold text-gray-900">เลือกประเภทอสังหาฯ</h1>
          </div>
        </motion.div>

        <div className="flex flex-col gap-2">
          {PROPERTY_TYPES.map((item, index) => (
            <PropertyCard key={item.link} {...item} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}
